module.exports = __webpack_public_path__ + "media/images/medupp-logo-light-23fc53e76b06b894a128cfdeddc18ff0.png";